export default __webpack_public_path__ + "static/media/img-0097-china-full-face.e7c6475a.png";